// extracted by mini-css-extract-plugin
export default {"blockSelector":"style_blockSelector__Xzvv4","carouselContainer":"style_carouselContainer__TFYgt","uninteracted":"style_uninteracted__a-nsY","breathe":"style_breathe__YW5ol"};